import React from 'react';
export function UltrixSection() {
  return <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden mb-12 transition-shadow hover:shadow-lg" data-id="element-1434">
      <div className="flex flex-col md:flex-row" data-id="element-1435">
        <div className="md:w-5/12 p-8 flex items-center justify-center bg-gray-50 border-b md:border-b-0 md:border-r border-gray-100" data-id="element-1436">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Ultrix.jpg" alt="ULTRIX" className="block max-w-full h-auto object-contain max-h-[300px]" data-id="element-1437" />
        </div>
        <div className="md:w-7/12 p-8 flex flex-col" data-id="element-1438">
          <h3 className="text-3xl font-bold text-[#9B0137] uppercase tracking-tight mb-2" data-id="element-1439">
            ULTRIX
          </h3>
          <h4 className="text-lg font-semibold text-navy mb-4 leading-snug" data-id="element-1440">
            5-Axis Vertical Machining Center with Trunnion Table For Milling and
            Turning with High Power and High Precision
          </h4>
          <div className="text-gray-700 mb-6 flex-grow space-y-4" data-id="element-1441">
            <p className="leading-relaxed" data-id="element-1442">
              A robust and stable Metalquartz base frame and a{' '}
              <strong data-id="element-1443">dedicated boring bar</strong> for a full range of
              operations on a single machining center. Ideal for{' '}
              <strong data-id="element-1444">
                roughing, semi-finishing and finishing operations on
                superalloys, steel, lightweight alloy, or composites.
              </strong>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 text-sm" data-id="element-1445">
              <div className="grid sm:grid-cols-3 gap-4" data-id="element-1446">
                <div data-id="element-1447">
                  <strong className="text-navy block mb-1" data-id="element-1448">ULTRIX 900</strong>
                  <p className="text-sm" data-id="element-1449">
                    X: 35.4 in.
                    <br data-id="element-1450" />
                    Y: 35.4 in.
                    <br data-id="element-1451" />
                    Z: 23.6 in.
                  </p>
                </div>
                <div data-id="element-1452">
                  <strong className="text-navy block mb-1" data-id="element-1453">ULTRIX 1200</strong>
                  <p className="text-sm" data-id="element-1454">
                    X: 45.3 in.
                    <br data-id="element-1455" />
                    Y: 39.4 in.
                    <br data-id="element-1456" />
                    Z: 27.6 in.
                  </p>
                </div>
                <div data-id="element-1457">
                  <strong className="text-navy block mb-1" data-id="element-1458">ULTRIX 1400</strong>
                  <p className="text-sm" data-id="element-1459">
                    X: 67 in.
                    <br data-id="element-1460" />
                    Y: 67 in.
                    <br data-id="element-1461" />
                    Z: 39.4 in.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-auto pt-4 border-t border-gray-100" data-id="element-1462">
            <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Ultrix" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1463">
              <span className="mr-2" data-id="element-1464">+</span> Request Quote
            </a>
            <a href="https://www.breton.it/products/machines-and-lines/breton-ultrix" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-1465">
              <span className="mr-2" data-id="element-1466">+</span> Additional Information
            </a>
          </div>
        </div>
      </div>
    </div>;
}